<template>
    <div :style="cssProps">
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">商品订单列表</h1>
                    <p class="text-white pb-3 px-3">เลือกจำนวนเครดิต หรือ ระบุจำนวนเครดิต เพื่อทำการเติมเข้ากระเป๋าของคุณ
                    </p>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow py-5">
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-lg-4">
                                    <date-range-picker
                                        class="w-100"
                                        :opens="'center'"
                                        :min-date="minDate"
                                        :max-date="maxDate"
                                        :singleDatePicker="false"
                                        :appendToBody="true"
                                        :ranges="false"
                                        :closeOnEsc="false"
                                        :autoApply="true"
                                        :locale-data="{ format: 'dd-mm-yyyy' }"
                                        v-model="search">
                                    </date-range-picker>
                                </div>
                                <div class="col-lg-4">
                                    <b-button variant="primary" @click="searchData">查询</b-button>
                                    <b-button variant="primary" @click="exportExcel">导出Excel</b-button>
                                </div>
                            </div>
                            <div class="mt-4">
                                <b-table
                                    ref="reportDelivery"
                                    show-empty
                                    responsive
                                    :items="tableList"
                                    :fields="fields"
                                    :per-page="pageSize"
                                    :busy="busy"
                                    selectable
                                    select-mode="multi"
                                    class="scroll-bar-pop text-center"
                                    empty-text="暂无数据"
                                    empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                                >
                                    <template slot="picUrl" slot-scope="{item}">
                                        <img :src="item.picUrl" v-if="item.picUrl" style="width: 128px;height:72px;" alt="">
                                        <img v-else src="@/assets/images/newImg/default-prod.png" style="width: 128px;height:72px;" alt="">
                                    </template>
                                    <template slot="action" slot-scope="{item}">
                                        <b-button size="sm" variant="primary" @click="printDemoWeb([item])">打印</b-button>
                                        <b-button size="sm" variant="danger" @click="handleDelete(item)">删除</b-button>
                                    </template>
                                </b-table>
                                <div class="mt-3">
                                    <b-pagination
                                        :total-rows="total"
                                        :current-page="pageIndex"
                                        :per-page="pageSize"
                                        :value="pageIndex"
                                        @input="changePage"
                                        align="right">
                                    </b-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {hexToRgbA} from "@/plugins/hexColor";
import {orderPage, removeOrder} from "@/api/productManagement";
import moment from "moment";
import {getTaxInfo} from "@/api/productManagement";
import secret from "@/utils/jsencryptKey";

export default {
    name: "",
    data() {
        return {
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            total: 0,
            busy: false,
            tableList: [],
            pageSize: 10,
            pageIndex: 1,
            fields: [
                {key: 'id', label: '订单号', sortable: true},
                {key: 'picUrl', label: '商品图片', sortable: true},
                {key: 'spuName', label: '商品名称', sortable: true},
                {key: 'salesCount', label: '数量', sortable: true},
                {key: 'sumRetailPrice', label: '销售总价(Vat7%)', sortable: true},
                {key: 'createTime', label: '下单时间', sortable: true},
                {key: 'action', label: '操作', sortable: true},
            ],
            search: {
                startDate: "",
                endDate: "",
            },
        }
    },
    created() {
        this.getDateNow(new Date())
    },
    mounted() {
        this.orderPage()
    },
    methods: {
        handleDelete(row) {
            this.$bvModal
                .msgBoxConfirm(`确定要删除这个记录吗？`, {
                    title: "กรุณายืนยัน",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "ยืนยัน",
                    cancelTitle: "ยกเลิก",
                    //for P' OOOO
                    contentClass: "modal-confirm",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        removeOrder({
                            id: row.id
                        }).then(res => {
                            this.pageIndex = 1;
                            this.orderPage();
                            this.$bvModal.msgBoxOk('操作成功', {
                                title: "SUCCESS",
                                size: "sm",
                                buttonSize: "sm",
                                okVariant: "success",
                                okTitle: "ตกลง",
                                contentClass: "modal-success",
                                headerClass: "p-2 border-bottom-0",
                                footerClass: "p-2 border-top-0",
                                centered: true
                            });
                        });
                    }
                })
        },
        async printDemoWeb(row) {
            console.log(row);
            if (row.length === 0) {
                return this.$message.error(this.$t("taxInfo.selectNeedReceipt"));
            }
            let res = await getTaxInfo();
            console.log(res);
            const { code, data, msg } = res;
            let params = {
                agentId: this.$store.state.loginUser.agentId,
                ids: row.map((item) => item.id),
                shopType: 1,
                isTax: !data ? 0 : 1, //是否可以打印发票
                printType: 2, //打印类型为回执,
                receiptSize: this.receiptSize
            };
            let param = JSON.stringify(params);
            try {
                let url = window.location.origin + `/print?params=${secret.aesEncryptCBC(param)}`
                window.open(url)
                // location.reload();
            } catch (e) {
                console.log("error");
            }
            // this.orderList = row;
            // this.receiptOptions.visible = true;
        },
        searchData() {
            this.pageIndex = 1
            this.orderPage()
        },
        getDateNow(myDate) {
            // 当前日期
            var year = myDate.getFullYear();
            var month = ("0" + (myDate.getMonth() + 1)).slice(-2);
            var date = ("0" + myDate.getDate()).slice(-2);
            var formattedDate = year + "-" + month + "-" + date;

            // 前一个月的同一天
            var lastMonthDate = new Date(myDate);
            lastMonthDate.setMonth(myDate.getMonth() - 1);

            // 处理跨年问题
            if (myDate.getMonth() === 0) {
                lastMonthDate.setFullYear(myDate.getFullYear() - 1);
                lastMonthDate.setMonth(11);
            }

            var lastMonthYear = lastMonthDate.getFullYear();
            var lastMonthMonth = ("0" + (lastMonthDate.getMonth() + 1)).slice(-2);
            var lastMonthDay = ("0" + lastMonthDate.getDate()).slice(-2);
            var formattedLastMonthDate = lastMonthYear + "-" + lastMonthMonth + "-" + lastMonthDay;

            // 设置时间区间
            this.search.startDate = formattedLastMonthDate;
            this.search.endDate = formattedDate;
        },
        orderPage() {
            this.busy = true
            orderPage({
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                endTime: this.search.endDate ? moment(this.search.endDate).format("YYYY-MM-DD") + ' 23:59:59' : "",
                startTime: this.search.startDate ? moment(this.search.startDate).format("YYYY-MM-DD") + ' 00:00:00' : "",
            }).then(res => {
                this.busy = false
                this.tableList = res.data.records
                this.total = res.data.total
            })
        },
        changePage(page) {
            if (page === this.pageIndex) return
            this.pageIndex = page
            this.orderPage()
        },
        exportExcel() {

        }
    },
    computed: {
        cssProps() {
            return {
                '--bg-hover-color': hexToRgbA('#11cdef', 0.7),
                '--bg-color': '#11cdef',
            }
        }
    }
};
</script>
<style scoped>

</style>